import { render, staticRenderFns } from "./crm-form-name.vue?vue&type=template&id=77a32945&scoped=true"
import script from "./crm-form-name.vue?vue&type=script&lang=js"
export * from "./crm-form-name.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77a32945",
  null
  
)

export default component.exports